<template>   
<div class="not-full-w" >  
    <MglMap 
    :style="size"   
    :accessToken="accessToken" 
    :center="st_johns"
    :zoom="8"
    :mapStyle="mapStyle"
     :attributionControl="false">
    <!-- <MglAttributionControl /> -->
        <MglFullscreenControl/>
        <MglNavigationControl position="top-right"/>
        <!-- <MglGeolocateControl position="top-right" />   -->
         

        
        <MglMarker :coordinates="st_johns" color="#9d06cf" />
        <!-- <MglMarker :coordinates="lilongwe" color="#f7a823" >
            <v-icon slot="marker" size="40" color="accent">mdi-map-marker</v-icon> 
        </MglMarker> -->
        
    </MglMap>
</div>
</template>

<script>  
import Mapbox from "mapbox-gl";
import {  
    MglMap, 
    MglAttributionControl,
    MglNavigationControl, 
    MglGeolocateControl,
    MglFullscreenControl,
    MglScaleControl,
    MglPopup,
    MglMarker  
} from "vue-mapbox";
// import MglGeocoderControl from "vue-mapbox-geocoder";
let ACCESS_TOKEN = "pk.eyJ1IjoicmVnaXNqZWFybWJlcmEiLCJhIjoiY2p1d2FscG9yMDJuYjRkcG8yc2xoNjc3YiJ9.A7halTxXC0lVxg5geUkLWQ"
let MAP_STYLE = "mapbox://styles/regisjearmbera/ck8eitf442ynk1io09z9pgs65" 
export default {
    props:[
        'mp_height',
        'mp_width',
        'mp_center',
        'mp_points',
        'mp_zoom'
    ],
    components: {
        MglMap,
        MglAttributionControl,
        MglNavigationControl,
        MglGeolocateControl,
        MglFullscreenControl,
    MglScaleControl,
        MglPopup,
        MglMarker 
        
    },
    data(){
        return{  
            visible:true,
            newMap:{},
            // malawi:{lat:-13.2543,lng:34.3015},
            // lilongwe:{lat:-13.9626,lng:33.7741},
            malawi:[34.3015,-13.2543],
            lilongwe:[33.7741,-13.9626],
            st_johns:[33.784584,-14.022322],
            accessToken: ACCESS_TOKEN, // your access token. Needed if you using Mapbox maps
            mapStyle: MAP_STYLE, // your map style
            defaultInput: "Bodhgaya",
            popupCoordinates: [10, 10]
        } 
    },
    mounted(){  
      
    },
    created(){  
        // We need to set mapbox-gl library here in order to use it in template
        this.mapbox = Mapbox;
    },
    computed:{ 
        size(){
            let h = this.mp_height?this.mp_height:"300px"
            let w = this.mp_width?this.mp_width:"100%"
            return " height:"+h+"; width:"+w+"; "
        }
    },
    methods:{ 
       handleSearch(event) {
        console.log(event);
        } 

    },
    watch:{
       
    } 
}
</script> 

